export default "__VITE_ASSET__T6Uo5OVn__"